
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_1nohd_153",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_1nohd_1",
  "refresh": "awsui_refresh_qwoo0_1nohd_174",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_1nohd_1",
  "root": "awsui_root_qwoo0_1nohd_199",
  "interior": "awsui_interior_qwoo0_1nohd_232",
  "dropdown": "awsui_dropdown_qwoo0_1nohd_153",
  "use-portal": "awsui_use-portal_qwoo0_1nohd_243",
  "is-empty": "awsui_is-empty_qwoo0_1nohd_289",
  "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_1nohd_296",
  "with-limited-width": "awsui_with-limited-width_qwoo0_1nohd_300",
  "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_1nohd_303",
  "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_1nohd_306",
  "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_1nohd_309",
  "stretch-beyond-trigger-width": "awsui_stretch-beyond-trigger-width_qwoo0_1nohd_312",
  "hide-block-border": "awsui_hide-block-border_qwoo0_1nohd_319",
  "open": "awsui_open_qwoo0_1nohd_328",
  "nowrap": "awsui_nowrap_qwoo0_1nohd_337",
  "dropdown-content": "awsui_dropdown-content_qwoo0_1nohd_153",
  "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_1nohd_348"
};
  